import { Plugin, PluginKey } from "tiptap";

import { Decoration, DecorationSet } from "prosemirror-view";
import store from "../store";

export default function OverQuotaPlugin() {
  return new Plugin({
    name: new PluginKey("over-quota"),
    props: {
      max: 30,
      decorations(state) {
        return DecorationSet.create(state.doc, [
          Decoration.inline(store.state.maxLength + 1, state.doc.content.size, {
            style: "color: red",
          }),
        ]);
      },
    },
  });
}
